var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9512_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1503 6.34999C16.5203 4.71999 14.2103 3.77999 11.6703 4.03999C8.00027 4.40999 4.98027 7.38999 4.57027 11.06C4.02027 15.91 7.77027 20 12.5003 20C15.6903 20 18.4303 18.13 19.7103 15.44C20.0303 14.77 19.5503 14 18.8103 14C18.4403 14 18.0903 14.2 17.9303 14.53C16.8003 16.96 14.0903 18.5 11.1303 17.84C8.91026 17.35 7.12027 15.54 6.65027 13.32C5.81027 9.43999 8.76027 5.99999 12.5003 5.99999C14.1603 5.99999 15.6403 6.68999 16.7203 7.77999L15.2103 9.28999C14.5803 9.91999 15.0203 11 15.9103 11L19.5003 11C20.0503 11 20.5003 10.55 20.5003 9.99999V6.40999C20.5003 5.51999 19.4203 5.06999 18.7903 5.69999L18.1503 6.34999Z",
    fill: "#303F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9512_1095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDark);
export default __webpack_public_path__ + "static/media/refresh-dark.05d3912611abffb9f0354a6a361dfe0f.svg";
export { ForwardRef as ReactComponent };